import * as React from "react";
import { DateField, TextField, EditButton, TextInput, FunctionField } from "react-admin";
import { Datagrid, IfCanAccess, List } from "src/enterprise/ra-rbac";
import { Chip } from "@mui/material";

const listFilters = [<TextInput source="search" label="Search" alwaysOn />];
export const FaqList = (props) => (
  <List {...props} filters={listFilters} queryOptions={{ cacheTime: 0 }}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="question" />
      <TextField source="sort_order" />
      <FunctionField
        label="Categories"
        render={(record) => {
          return (
            <div style={{ display: "flex", gap: 4 }}>
              {record.categories.map((category, index) => {
                return (
                  <Chip
                  key={`${index}-${category.id}`}
                    label={category?.name}
                  />
                );
              })}
            </div>
          );
        }}
      />
      <DateField source="created_at" label="Created At" />
      <IfCanAccess action="edit">
        <EditButton />
      </IfCanAccess>
    </Datagrid>
  </List>
);
